// 3rd party
import React from "react";
import { FormattedMessage } from "react-intl";
import { Grid } from "@material-ui/core";
import { Header } from "../common/title/header";
import { Card } from "../common/card/card";
import { phoneNumberFormatterValue } from "../common/dataList/dataListHelper";
import { useWorkOrderStyles, Caption, Value, CardTitle } from "./workOrderDetails";

const WorkOrderCustomerInfo = ({ workOrderData, relatedIdInformation }) => {
    const classes = useWorkOrderStyles();

    if (!relatedIdInformation?.tasks?.workType) {
        return null;
    }
    return (
        <>
            {relatedIdInformation?.tasks?.workType?.displayCustomerInfo && (
                <Grid container spacing={2}>
                    <Grid item xs={12} className={classes.noBottomPadding}>
                        <Header>
                            <FormattedMessage
                                id="admin.work-order-details.wo-info.customer-location-info-title"
                                defaultMessage="Customer and location information"
                                description="Admin work order customer and location information title"
                            />
                        </Header>
                    </Grid>
                    <Grid item xs={6}>
                        <Card>
                            <CardTitle>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.customer-info-title"
                                    defaultMessage="Customer Location Information"
                                    description="Admin work order customer information title"
                                />
                            </CardTitle>
                            <Grid container className={classes.row}>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.co-info.location.civic-number-caption"
                                            defaultMessage="Civic Number"
                                            description="Admin work order Civic number caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.civicAddress}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.co-info.location.street-caption"
                                            defaultMessage="Street Name"
                                            description="Admin work order Street name caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.locationStreet}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.co-info.location.apartment-floor-caption"
                                            defaultMessage="Apartment/ Unit/ Floor"
                                            description="Admin work order Apartment unit floor caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.unitNumber}</Value>
                                </Grid>
                            </Grid>
                            <Grid container className={classes.row}>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.postal-code-caption"
                                            defaultMessage="Postal code"
                                            description="Admin work order Postal code caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.postalCode}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.municipality-caption"
                                            defaultMessage="Municipality"
                                            description="Admin work order Municipality caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.municipality}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.province-caption"
                                            defaultMessage="Province"
                                            description="Admin work order Province caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.province}</Value>
                                </Grid>
                            </Grid>
                            <Grid container className={classes.row}>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.customer.source-ticket-id-caption"
                                            defaultMessage="Source ticket ID"
                                            description="Admin work order Source ticket ID caption"
                                        />
                                    </Caption>
                                    <Value>{workOrderData.sourceOrderId}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.customer.customer-name-caption"
                                            defaultMessage="Customer name"
                                            description="Admin work order Customer name caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation.customerName}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.customer.customer-preferred-contact-method-caption"
                                            defaultMessage="Customer Preferred Contact Method"
                                            description="Admin work order Customer Preferred Contact Method caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation.customerPreferredContactMethod}</Value>
                                </Grid>
                            </Grid>
                            <Grid container className={classes.row}>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.customer.customer-phone-caption"
                                            defaultMessage="Customer phone #"
                                            description="Admin work order Customer phone # caption"
                                        />
                                    </Caption>
                                    <Value>{phoneNumberFormatterValue(relatedIdInformation?.customerPhoneNumber)}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.customer.preferred-phone-caption"
                                            defaultMessage="Preferred phone #"
                                            description="Admin work order Preferred phone # caption"
                                        />
                                    </Caption>
                                    <Value>{phoneNumberFormatterValue(relatedIdInformation.PreferredContact)}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.customer.business-residential-customer-caption"
                                            defaultMessage="Business or Residential Customer"
                                            description="Admin work order Business or Residential Customer caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation.business}</Value>
                                </Grid>
                            </Grid>
                            <Grid container className={classes.row}>
                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.customer.circuit-num-caption"
                                            defaultMessage="Circuit #"
                                            description="Admin work order Circuit # caption"
                                        />
                                    </Caption>
                                    <Value>{workOrderData.circuitNumber}&nbsp;</Value>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>

                    <Grid item xs={6}>
                        <Card>
                            <CardTitle>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.location-info-title"
                                    defaultMessage="Work Location Information"
                                    description="Admin work order location information title"
                                />
                            </CardTitle>
                            <Grid container className={classes.row}>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.civic-address-caption"
                                            defaultMessage="Civic address"
                                            description="Admin work order Civic address caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.workCivicAddress}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.street-caption"
                                            defaultMessage="Street"
                                            description="Admin work order Street caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.workStreet}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.apartment-floor-caption"
                                            defaultMessage="Apartment floor"
                                            description="Admin work order Apartment floor caption"
                                        />
                                    </Caption>
                                    {workOrderData?.apartmentFloor?.split("Suite:")[1] != "" ? (
                                        <Value>{workOrderData?.apartmentFloor}</Value>
                                    ) : (
                                        <Value>{"Suite:" + relatedIdInformation?.workUnitNumber}</Value>
                                    )}
                                    {/* <Value>{workOrderData.apartmentFloor}</Value> */}
                                </Grid>
                            </Grid>
                            <Grid container className={classes.row}>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.postal-code-caption"
                                            defaultMessage="Postal code"
                                            description="Admin work order Postal code caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.workPostalCode}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.municipality-caption"
                                            defaultMessage="Municipality"
                                            description="Admin work order Municipality caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.workMunicipality}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.province-caption"
                                            defaultMessage="Province"
                                            description="Admin work order Province caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.workProvince}</Value>
                                </Grid>
                            </Grid>
                            <Grid container className={classes.row}>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.clli-code-caption"
                                            defaultMessage="CLLI Code"
                                            description="Admin work order CLLI Code caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.tasks?.zone}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.intersection-1-caption"
                                            defaultMessage="Intersection 1"
                                            description="Admin work order Intersection 1 caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.intersection1}</Value>
                                </Grid>
                                <Grid item xs={4}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.location.intersection-2-caption"
                                            defaultMessage="Intersection 2"
                                            description="Admin work order Intersection 2 caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.intersection2}</Value>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default WorkOrderCustomerInfo;
